/**
 * Basic CSV Export component for Free and Plus users
 */

import React, { useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Alert,
  CircularProgress
} from '@mui/material';
import {
  Download as DownloadIcon,
  GetApp as GetAppIcon
} from '@mui/icons-material';
import exportService from '../services/exportService';

const BasicExport = ({ variant = 'contained', size = 'medium', showLabel = true }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExport = async (type) => {
    setLoading(true);
    setError('');
    setMessage('');
    handleClose();

    try {
      let result;
      if (type === 'items') {
        result = await exportService.exportItems();
      } else if (type === 'boxes') {
        result = await exportService.exportBoxes();
      }

      if (result.success) {
        setMessage(result.message);
        // Clear message after 3 seconds
        setTimeout(() => setMessage(''), 3000);
      } else {
        setError(result.error);
        // Clear error after 5 seconds
        setTimeout(() => setError(''), 5000);
      }
    } catch (err) {
      setError(err.message || 'Export failed');
      setTimeout(() => setError(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Button
        variant={variant}
        size={size}
        startIcon={loading ? <CircularProgress size={16} /> : <DownloadIcon />}
        onClick={handleClick}
        disabled={loading}
      >
        {showLabel && (loading ? 'Exporting...' : 'Export CSV')}
        {!showLabel && !loading && <GetAppIcon />}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={() => handleExport('items')}>
          Export Items
        </MenuItem>
        <MenuItem onClick={() => handleExport('boxes')}>
          Export Boxes
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default BasicExport;
